import img from "@/assets/money/pyramid-painted.jpg";
import { PYRAMID, type PyramidStatus } from "@/lib/desk/foundations";

// Tier faces in the painting (px of 1280x896), bottom (Survival) to top (Legacy).
const FACES = [
  [247, 605, 1031, 707],
  [332, 475, 946, 567],
  [405, 357, 875, 442],
  [470, 247, 810, 322],
  [527, 145, 752, 215],
];
const W = 1280, H = 896;

/** Painted marble pyramid; each tier fills with gold as it's built, the working tier glows. */
export default function PaintedPyramid({ status, className = "" }: { status: PyramidStatus; className?: string }) {
  return (
    <div className={`relative overflow-hidden rounded-xl border-2 border-gold/50 shadow-md ${className}`} role="img" aria-label={`Foundation, level ${status.level} of 5`}>
      <img src={img} alt="" width={W} height={H} loading="lazy" className="block h-auto w-full" />
      {FACES.map(([x1, y1, x2, y2], i) => {
        const n = i + 1;
        const lv = PYRAMID[i];
        const repair = status.repair === n;
        const done = n <= status.level && !repair;
        const working = !repair && n === status.working && status.level < 5;
        return (
          <div key={n} className="absolute flex items-center justify-center"
            style={{ left: `${(x1 / W) * 100}%`, top: `${(y1 / H) * 100}%`, width: `${((x2 - x1) / W) * 100}%`, height: `${((y2 - y1) / H) * 100}%` }}>
            {(done || working || repair) && (
              <div className={`absolute inset-0 `}
                style={{
                  background: repair ? "hsl(var(--destructive) / 0.35)" : done ? "linear-gradient(hsl(var(--gold) / 0.9), hsl(var(--bronze-dark) / 0.9))" : "linear-gradient(hsl(var(--gold) / 0.75), hsl(var(--bronze) / 0.8))",
                  boxShadow: working ? "0 0 22px hsl(var(--gold)), inset 0 0 0 2px hsl(var(--gold))" : undefined,
                  mixBlendMode: done ? "multiply" : "normal",
                }} />
            )}
            <span className="relative font-serif text-[9px] sm:text-sm font-semibold uppercase tracking-[0.14em] sm:tracking-[0.2em]"
              style={done || working ? { color: "hsl(var(--card))", textShadow: "0 1px 2px hsl(var(--bronze-dark))" } : { color: "hsl(var(--bronze-dark))", textShadow: "0 1px 0 hsl(0 0% 100% / 0.6)" }}>
              {n === 5 ? lv.name : `${lv.name}${done ? " ✓" : repair ? " · repair" : ""}`}
            </span>
          </div>
        );
      })}
    </div>
  );
}
